export default __webpack_public_path__ + "static/media/restart.9a25b02d.png";